import EnvironmentEdit from "./EnvironmentEdit";

export default function RHEnvironmentDetailPage() {
  return <EnvironmentEdit></EnvironmentEdit>;
}
